import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SocketState {
  socketData: object;
  isConnected: boolean;
}

const initialState: SocketState = {
  socketData: {},
  isConnected: false
};

const slice = createSlice({
  name: 'socket',
  initialState,
  reducers: {
    setSocketData(state: SocketState, action: PayloadAction<any>) {
      const { socketData, isConnected } = action.payload;
      state.socketData = socketData;
      state.isConnected = isConnected;
    },
    setPosDeviceIdentifier(state: SocketState, action: PayloadAction<any>) {
      const { posDeviceIdentifier } = action.payload;
      state.socketData = { ...state.socketData, posDeviceIdentifier };
    },
    disconnect(state: SocketState) {
      state.isConnected = false;
      state.socketData = null;
    },
    clearData(state: SocketState) {
      state.socketData = null;
    }
  }
});

export const {
  setSocketData,
  disconnect,
  clearData,
  setPosDeviceIdentifier
} = slice.actions;
export const reducer = slice.reducer;
export default slice;
